import { formatUnits, parseUnits } from "viem";

export const USDT_DECIMALS = 18;
const FIXED_PARTICIPATION_USDT = "1000";
export const FIXED_PARTICIPATION_RAW = parseUnits(
  FIXED_PARTICIPATION_USDT,
  USDT_DECIMALS
);

export function hasParticipationBalance(balance: bigint | undefined): boolean {
  return balance !== undefined && balance >= FIXED_PARTICIPATION_RAW;
}

export function formatUsdtBalance(balance: bigint | undefined): string {
  if (balance === undefined) return "0.000";
  const [whole = "0", fraction = ""] = formatUnits(balance, USDT_DECIMALS).split(".");
  return `${BigInt(whole).toLocaleString("en-US")}.${fraction.padEnd(3, "0").slice(0, 3)}`;
}
